import React from 'react';
import { IfmsRoute }from '../../../config/types';

export const OiMblView = React.lazy(() => import('../mbl/OiMblView'));
export const OiHblView = React.lazy(() => import('../hbl/OiHblView'));
const OiLoadPlanView = React.lazy(() => import('../loadPlan/OiLoadPlanView'));
const OiQuotationView = React.lazy(() => import('../../oceanImport/quotation/OiQuotationView'));
const OeQuotationView = React.lazy(() => import('../../oceanExport/quotation/OeQuotationView'));
const OiMblBillingsView = React.lazy(() => import('../mbl/OiMBillingsView'));
const OiHblBillingsView = React.lazy(() => import('../hbl/OiHBillingsView'));
const MblArrivalNoticeView = React.lazy(() => import('../../reports/MblArrivalNoticeView'));
const DevanningInstructionVIew = React.lazy(() => import('../../reports/DevanningInstructionVIew'));
const FolderLabelView = React.lazy(() => import('../../reports/FolderLabelView'));
const MblHoldNoticeView = React.lazy(() => import('../../reports/MblHoldNoticeView'));
const MasterInvoiceView = React.lazy(() => import('../../reports/MasterInvoiceView'));
const HblArrivalNoticeView = React.lazy(() => import('../../reports/HblArrivalNoticeView'));
const ArrivalReleaseNoticeView = React.lazy(() => import('../hbl/more/ArrivalReleaseNoticeView'));
const CorrectionNoticeView = React.lazy(() => import('../../reports/CorrectionNoticeView'));
const DeliveryOrderView = React.lazy(() => import('../../reports/DeliveryOrderView'));
const PickupDeliveryView = React.lazy(() => import('../../reports/PickupDeliveryView'));
const HoldNoticeView = React.lazy(() => import('../hbl/more/HoldNoticeView'));
const CargoManifestStatusView = React.lazy(() => import('../../reports/CargoManifestStatusView'));
const SendShipmentStatusView = React.lazy(() => import('../../reports/SendShipmentStatusView'));
const EmptyContainerReturnGuaranteeView = React.lazy(() => import('../hbl/more/EmptyContainerReturnGuaranteeView'));
const CancelNoticeView = React.lazy(() => import('../hbl/more/CancelNoticeView'));
const ItTeNoticeView = React.lazy(() => import('../../reports/ItTeNoticeView'));
const LienNoticeView = React.lazy(() => import('../hbl/more/LienNoticeView'));
const MemoListView = React.lazy(() => import('../../reports/MemoListView'));
const PackageLabelView = React.lazy(() => import('../../reports/PackageLabelView'));
const PreliminaryClaimNoticeView = React.lazy(() => import('../../reports/PreliminaryClaimNoticeView'));
const ProofOfDeliveryView = React.lazy(() => import('../../reports/ProofOfDeliveryView'));
const ReleaseOrderTurnoverView = React.lazy(() => import('../../reports/ReleaseOrderTurnoverView'));
const StraightBlView = React.lazy(() => import('../../reports/StraightBlView'));
const ArrivalNoticeLogView = React.lazy(() => import('../reports/ArrivalNoticeLogView'));
const ShipmentReportView = React.lazy(() => import('../reports/ShipmentReportView'));
const ReleaseHistoryView = React.lazy(() => import('../reports/ReleaseHistoryView'));
const PendingCargoView = React.lazy(() => import('../reports/PendingCargoView'));
const InlandTransportationView = React.lazy(() => import('../reports/InlandTransportationView'));
export const LiftingReportView = React.lazy(() => import('../ams/LiftingReport'));
export const UsageReportView = React.lazy(() => import('../ams/UsageReport'));
export const ISFUsageReportView = React.lazy(() => import('../isf/UsageReportView'));
const DownloadView = React.lazy(() => import('../../common/DownloadView'));
const IsfDownloadView = React.lazy(() => import('../../common/IsfDownloadView'));

const routes:Array<IfmsRoute> = [
  {path: '/oceanImport/mbl/:mode/:id?/:tabIndex?/:createEntity?/:opAcctIds?', component: OiMblView},
  {path: '/oceanImport/hbl/:mode/:id?/:tabIndex?/:createEntity?/:opAcctIds?', component: OiHblView},
  {path: '/oceanImport/loadPlan/:mode/:id?', component: OiLoadPlanView},
  {path: '/oceanImport/quotation/:mode/:id?', component: OiQuotationView},
  {path: '/oceanImport/viewBillings/mbl/:id?', component: OiMblBillingsView},
  {path: '/oceanImport/viewBillings/hbl/:id?', component: OiHblBillingsView},

  //OIM Moremenu
  {path: '/oceanImport/arrivalnotice', component: MblArrivalNoticeView},
  {path: '/oceanImport/devanninginstruction', component: DevanningInstructionVIew},
  {path: '/oceanImport/mblholdnotice', component: MblHoldNoticeView},
  {path: '/oceanImport/masterinvoice', component: MasterInvoiceView},

  //OIH Moremenu
  {path: '/oceanImport/hblArrivalNotice', component: HblArrivalNoticeView},
  {path: '/oceanImport/arrivalReleaseNotice', component: ArrivalReleaseNoticeView},
  {path: '/oceanImport/shortDeliveryOrder', component: DeliveryOrderView},
  {path: '/oceanImport/preDeliveryOrder', component: DeliveryOrderView},
  {path: '/oceanImport/hblHoldNotice', component: HoldNoticeView},
  {path: '/oceanImport/sendShipmentStatus', component: SendShipmentStatusView},
  {path: '/oceanImport/emptyContainerReturnGuarantee', component: EmptyContainerReturnGuaranteeView},
  {path: '/oceanImport/cancelNotice', component: CancelNoticeView},
  {path: '/oceanImport/itTeNotice', component: ItTeNoticeView},
  {path: '/oceanImport/lienNotice', component: LienNoticeView},
  {path: '/oceanImport/packageLabel', component: PackageLabelView},
  {path: '/oceanImport/preliminaryClaimNotice', component: PreliminaryClaimNoticeView},
  {path: '/oceanImport/proofOfDelivery', component: ProofOfDeliveryView},
  { path: '/oceanImport/releaseOrderTurnover', component: ReleaseOrderTurnoverView },
  { path: '/oceanImport/straightBl', component: StraightBlView },
  { path: '/oceanImport/memoCustomerList', component: MemoListView },

  //common Moremenu
  { path: '/oceanImport/correctionNotice', component: CorrectionNoticeView },
  { path: '/oceanImport/pickupDelivery', component: PickupDeliveryView },
  { path: '/oceanImport/cargoManifestStatus', component: CargoManifestStatusView },
  { path: '/oceanImport/memoList', component: MemoListView },
  { path: '/oceanImport/folderLabel', component: FolderLabelView },
  
  //ACI
  { path: '/oceanImport/aciUsageReport', component: UsageReportView },
  { path: '/oceanImport/aciLiftReport', component: LiftingReportView },
  { path: '/oceanImport/aciTotLiftReport', component: LiftingReportView },
  //Download
  { path: '/oceanImport/download/isf/:id?', component: IsfDownloadView },
  { path: '/oceanImport/download/:jobName?/:id?', component: DownloadView },

  //report
  { path: '/oceanImport/arrivalnoticelog', component: ArrivalNoticeLogView },
  { path: '/oceanImport/inlandTransportation', component: InlandTransportationView },
  { path: '/oceanImport/pendingCargo', component: PendingCargoView },
  { path: '/oceanImport/releaseHistory', component: ReleaseHistoryView },
  { path: '/oceanImport/shipmentReport', component: ShipmentReportView },
];

export default routes;
